import moment from 'moment'

export function formatDate (time: number): string {
  return moment(time).format('YYYY/MM/DD')
}

export function formatTime (time: number): string {
  return moment(time).format('YYYY/MM/DD HH:mm')
}

export function formatCurrency(amount: any): any {
  return (new Intl.NumberFormat('ja-JP').format(amount))
}
